import { render, staticRenderFns } from "./CommonWaitingListTable.vue?vue&type=template&id=461a8eaf"
import script from "./CommonWaitingListTable.vue?vue&type=script&lang=js"
export * from "./CommonWaitingListTable.vue?vue&type=script&lang=js"
import style0 from "./CommonWaitingListTable.vue?vue&type=style&index=0&id=461a8eaf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports